var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flag)?_c('div',{staticClass:"prism-player",style:(_vm.playStyle),attrs:{"id":_vm.playerId},on:{"playbackFinished":_vm.handlePlaybackFinished}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }